import unauthorize from "../../assets/imgs/unauthorize.png";
import { Grid2 } from "@mui/material";

const UnAthorize = () => {
  return (
    <div className="content-body">
      <div
        style={{
          alignContent: "center",
          margin: "auto",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <img
          src={unauthorize}
          alt="unauthorize"
          style={{
            margin: "auto",
          }}
        />
        <h4
          style={{
            color: "#337ab7",
          }}
        >
          Unauthorize Access
        </h4>
      </div>

      <Grid2
        alignItems={"center"}
        justifyContent="center"
        container
        sx={{ marginTop: "2%" }}
      >
        <Grid2 item md={6}>
          <button
            className="create-btn"
            onClick={() => {
              window.location.href = "https://genesis.augursapps.com/login";
            }}
          >
            Back to Genesis Login.
          </button>
        </Grid2>
      </Grid2>
    </div>
  );
};

export default UnAthorize;
